<app-modal
    [dismissible]="false"
    [autoZIndex]="autoZIndex"
    [baseZIndex]="baseZIndex"
    class="popup-info">
    <div class="modal-header"
         modal-header>
        <h3 class="modal-title">{{ title }}</h3>
    </div>
    <div class="modal-body" modal-body>
        <p class="info-message">{{ infoMessage }}</p>
        <span>{{ 'generic.components.logoutModal.message' | translate }}</span>
        <h5><b>{{ countdown + 1 }}</b> {{ ('timeUnits.seconds' | translate).toLowerCase() }}</h5>
    </div>
    <div class="modal-footer" modal-footer>
        <app-button
            type="primary"
            (clicked)="close()">{{ "generic.components.logoutModal.continue" | translate }}
        </app-button>
    </div>
</app-modal>
